import { useLocation } from 'react-router-dom';

type UseURLSearchParams = {
  audienceId: string;
  audienceType: string;
  categoryId: string | null;
  categoryName: string | null;
};

export const useURLSearchParams = (): UseURLSearchParams => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const audienceId = searchParams.get('audienceId') || 'all';
  const audienceType = searchParams.get('audienceType') || 'school';
  const categoryId = searchParams.get('categoryId');
  const categoryName = searchParams.get('categoryName');

  return { audienceId, audienceType, categoryId, categoryName };
};
